<template>
  <div class="scenario-container muzik-composer mk-container">
    <Breadcrumbs :breadcrumbs="breadcrumbs" />
    <div v-if="loaded">
      <LayoutInnerPage v-if="trackData && trackData.movement" :class="{'unite': notHasRelativeInfo}">
        <template slot="left">
          <PeopleTrack :label-id="trackData.composer_id"
                       :label="composerName"
                       :title="trackName"
                       :alias-title="$t('WORK.WORK_ALIAS')"
                       :alias="displayWorkAliases(trackData.movement.work)"
                       :performer-date="trackData.performer"
                       @play-track="setTrackToQueue(trackData)"
                       @add-to-playlist="addToPlaylist"
                       @open-share-track="openShareTrack = true"
          />
          <Paganiniplus />
        </template>
        <template slot="right">
          <PeopleAccordion v-if="otherTrack[$route.params.id].length"
                           :content="otherTrack" :title="$t('MOVEMENT.OTHER_VERSIONS')" type="track"
                           @play-track-list="playTrackList"
          />
          <PeopleIntro :title="$t('COMPOSER.COMPOSER_INTRO')"
                       :img-src="trackData.movement.work.people && trackData.movement.work.people.file_link ? trackData.movement.work.people.file_link : ''"
                       :desp="displayComposerDescription(trackData.movement.work.people)"
          />
          <PeopleIntro :title="$t('WORK.WORK_INTRO')"
                       :desp="displayWorkDescription(trackData.movement.work)"
          />
        </template>
      </LayoutInnerPage>
      <CommonDummy v-else
                   :title="$t('DUMMY.LISTEN_COMMON')"
      />
    </div>
    <div v-else class="loader-container">
      <Loader />
    </div>

    <PlaylistGoLoginModal
      :open="openGoToLoginModal"
      @close="openGoToLoginModal = false"
    />
    <PlaylistTrackAddingModal
      :open="openAddingModal"
      :selected-track="trackData"
      :display-track-name="displayTrackName"
      @close="openAddingModal = false"
    />

    <TrackShareModal
      v-if="trackData && trackData.id"
      :title="`${composerName} - ${workName} - ${trackName}`"
      :open="openShareTrack"
      :track="trackData"
      @close="openShareTrack = false"
    />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Breadcrumbs from '@/components/common/Breadcrumbs'
import CommonDummy from '@/components/common/DummyStatus/CommonDummy'
import Loader from '@/components/common/Loader'
import Paganiniplus from '@/components/tsp/Paganiniplus'
import LayoutInnerPage from '@/components/people/LayoutInnerPage'
import PeopleTrack from '@/components/people/PeopleTrack'
import PeopleAccordion from '@/components/people/PeopleAccordion'
import PeopleIntro from '@/components/people/PeopleIntro'
import TrackService from '@/assets/services/TrackService'
import PlaylistGoLoginModal from '@/components/playlist/PlaylistGoLoginModal'
import PlaylistTrackAddingModal from '@/components/playlist/PlaylistTrackAddingModal'
import TrackShareModal from '@/components/track/TrackShareModal'
import {
  displayTrackName,
  displayComposerName,
  displayComposerDescription,
  displayPerformerName,
  displayPerformerPosition
} from '@/assets/helpers/TrackHelper.js'
import { displayWorkName, displayWorkAliases, displayWorkDescription } from '@/assets/helpers/WorkHelper'
import { displayMovementName } from '@/assets/helpers/MovementHelper'

export default {
  name: 'WorkById',
  components: {
    Paganiniplus,
    Loader,
    CommonDummy,
    Breadcrumbs,
    LayoutInnerPage,
    PeopleTrack,
    PeopleAccordion,
    PeopleIntro,
    PlaylistGoLoginModal,
    PlaylistTrackAddingModal,
    TrackShareModal
  },
  data() {
    return {
      loaded: false,
      trackData: {},
      otherTrack: {},
      openGoToLoginModal: false,
      openAddingModal: false,
      openShareTrack: false,
      genreIdOfNonOpera: [
        '8ba888b3-7dc0-4a82-ad65-d6ea5c44118a',
        '8ba888b3-4efb-4a5e-b4f1-adbe56a41c69',
        '8ba888b3-8da5-411c-a759-819cf30aa438',
        '8ba888b2-e4a7-4ca9-b7b4-7cc689fe17a4',
        '8ba888b3-7ddf-44f4-b647-97506542e306',
        '8ba888b3-777a-4c73-a3cd-73b1c469b6d0',
        '8ba888b3-2a8f-4ae2-9597-ec2f49b7adee',
        '8ba888b3-570f-4f12-9c87-ac3d2120c4a9',
        '8ba888b3-2305-461d-8ce5-c883140514a8',
        '8ba888b3-9d41-4dd5-89ed-4be6088a299e',
        '8ba888b2-f4f4-4f85-b297-b4bd1af8a697',
        '8ba888b3-8885-4ac5-8014-5030ef3e080d',
        '8ba888b3-6950-4b80-8fa8-41a0ba21acdd',
        '8ba888b3-1636-4641-93d9-21f4784134c1',
        '8ba888b3-3498-408b-b528-3d157ba4b098',
        '8ba888b2-cdbd-4408-8622-e09e9fc84ac6',
        '8ba888b3-5589-48a2-bca2-cf99ae3b18f1',
        '8ba888b2-b78e-4bf1-bd6b-2a868f109088',
        '8ba888b3-02cb-49a1-9bc9-a9e4e038e0d1',
        '8ba888b3-29b7-4834-af14-f45b3c974c42',
        '8ba888b3-19a9-4576-a6ba-82199e23e6d6',
        '8ba888b3-4483-4ca5-9987-e9ca7074a0e7',
        '8ba888b3-8ef7-463a-adbc-ccc7ce84f569',
        '8ba888b3-0ef6-4f72-a36b-ec8d07c7643f',
        '8ba888b3-2ecc-4dc1-862c-97f8c15b9398',
        '8ba888b3-71e8-4125-969f-7c99259f050c',
        '8ba888b3-4643-469e-aeb7-84433562752d',
        '8ba888b3-114e-4258-98d5-f2b00d9f275c',
        '8ba888b2-de09-4266-b776-0b15a8acaf65',
        '8ba888b3-5250-4016-a6d4-30a6707495d9',
        '8ba888b3-68f6-4632-aa57-6e8212262558',
        '8ba888b3-2cce-4574-ad4d-88ac91e2918c',
        '8ba888b3-7ca4-446f-9a4e-cdf5856eb85b',
        '8ba888b2-f95d-44fb-a1d2-50ac0a975c1e',
        '8ba888b3-b493-4bc1-87b5-9317ce8cbdc4',
        '8ba888b2-c023-471b-9f9d-de932c03a46a',
        '8ba888b3-44df-4dcd-b3d8-8cde6edfe3be',
        '8ba888b3-ac2c-40ac-ad25-5317576f5f32',
        '8ba888b2-e5c5-40c2-b003-130c6fb948f9'
      ]
    }
  },
  metaInfo() {
    return {
      title: this.title,
      meta: [
        ...this.$route.meta.metaInfo.meta,
        { vmid: 'name', name: 'name', content: this.title },
        { vmid: 'description', name: 'description', content: this.description },
        { vmid: 'keywords', name: 'keywords', content: this.keywords },
        { vmid: 'image', name: 'image', content: this.cover },
        { vmid: 'og:title', name: 'og:title', content: this.title },
        { vmid: 'og:description', name: 'og:description', content: this.description },
        { vmid: 'og:image', name: 'og:image', content: this.cover }
      ],
      link: [
        { vmid: 'canonical', rel: 'canonical', href: this.canonicalURL },
        { vmid: 'image_src', rel: 'image_src', href: this.cover }
      ],
      __dangerouslyDisableSanitizers: ['script'],
      script: [{ innerHTML: JSON.stringify(this.structuredData), type: 'application/ld+json' }]
    }
  },
  computed: {
    ...mapState({
      initialClick: state => state.player.initialClick,
      currentTrackId: state => state.player.id
    }),
    ...mapGetters(['isAuthenticated']),
    breadcrumbs() {
      let breadcrumbsAry = []
      const indexBreadcrumbs = { routeName: 'index', localeLabel: 'LISTEN.TITLE', redirectPath: '' }
      breadcrumbsAry.push(indexBreadcrumbs)
      if (this.composerName && this.trackData.composer_id) {
        const composerBreadcrumbs = {
          routeName: 'composerById',
          routeParams: {
            id: this.trackData.composer_id
          },
          localeLabel: this.composerName || 'COMMON.COMPOSER',
          redirectPath: ''
        }
        breadcrumbsAry.push(composerBreadcrumbs)
      }
      if (this.workName && this.trackData.movement && this.trackData.movement.work_id) {
        const workBreadcrumbs = {
          routeName: 'workById',
          routeParams: {
            workId: this.trackData.movement.work_id
          },
          localeLabel: this.workName || 'COMMON.WORK',
          redirectPath: ''
        }
        breadcrumbsAry.push(workBreadcrumbs)
      }
      if (this.movementName) {
        const trackBreadcrumbs = {
          routeName: 'trackById',
          localeLabel: this.movementName || 'COMMON.TRACK',
          redirectPath: ''
        }
        breadcrumbsAry.push(trackBreadcrumbs)
      }
      return breadcrumbsAry
    },
    locale() {
      return this.$i18n.locale.toLowerCase()
    },
    workName() {
      return this.trackData && this.trackData.movement ? this.displayWorkName(this.trackData.movement.work) : ''
    },
    movementName() {
      return this.trackData && this.trackData.movement ? this.displayMovementName(this.trackData.movement) : ''
    },
    trackName() {
      return this.workName && this.movementName
        ? this.workName === this.movementName ? this.movementName : this.workName + ' - ' + this.movementName
        : ''
    },
    composerName() {
      return this.trackData && this.trackData.movement
        ? this.displayComposerName(this.trackData.movement.work.people)
        : ''
    },
    notHasRelativeInfo() {
      const otherTrack = this.otherTrack[this.$route.params.id].length
      const composerDesp = this.displayComposerDescription(this.trackData.movement.work.people)
      const workDesp = this.displayWorkDescription(this.trackData.movement.work)
      return otherTrack === 0 && composerDesp === '' && workDesp === ''
    },
    // default meta data, update after fetched track
    title() {
      const postfixTitle = `${this.$i18n.t('LISTEN.TITLE')} | MUZIK AIR`
      return this.composerName && this.workName && this.trackName
        ? `${this.trackName} - ${this.composerName} | ${postfixTitle}`
        : postfixTitle
    },
    description() {
      return this.trackData && this.trackData.movement && this.trackData.movement.work
        ? `${this.displayWorkDescription(this.trackData.movement.work).slice(0, 200)}` || this.$i18n.t('TRACK.TITLE')
        : this.$i18n.t('TRACK.TITLE')
    },
    keywords() {
      let keywordsAry = []
      keywordsAry.push(this.$i18n.t('TRACK.TITLE'))
      keywordsAry.push(this.trackName)
      keywordsAry.push(this.composerName)
      if (this.trackData && this.trackData.performer) {
        Object.keys(this.trackData.performer).forEach(item => {
          if (this.trackData.performer[item].position && this.trackData.performer[item].position[0]) {
            keywordsAry.push(this.displayPerformerPosition(this.trackData.performer[item].position[0]))
          }
          keywordsAry.push(this.displayPerformerName(this.trackData.performer[item]))
        })
      }
      if (this.otherTrack) {
        Object.keys(this.otherTrack).forEach(item => {
          this.otherTrack[item].forEach((track, index) => {
            if (index === 0) {
              track.performers.forEach(person => {
                keywordsAry.push(this.displayPerformerName(person.people))
              })
            }
            keywordsAry.push(this.displayMovementName(track.movement))
          })
        })
      }
      keywordsAry.push(this.description)
      return keywordsAry.join(', ')
    },
    cover() {
      return this.trackData &&
        this.trackData.movement &&
        this.trackData.movement.work &&
        this.trackData.movement.work.people &&
        this.trackData.movement.work.people['file_link']
        ? this.trackData.movement.work.people['file_link']
        : `https://${process.env.VUE_APP_MUZIK_LISTEN}.${process.env.VUE_APP_MUZIK_DOMAIN}/img/cover-social/listen.png`
    },
    canonicalURL() {
      return this.trackData && this.trackData.id
        ? `https://${process.env.VUE_APP_MUZIK_LISTEN}.${
          process.env.VUE_APP_MUZIK_DOMAIN
        }/${this.$i18n.localePath()}/tracks/${this.trackData.id}`
        : `https://${process.env.VUE_APP_MUZIK_LISTEN}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}`
    },
    structuredData() {
      if (this.trackData && this.trackData.id) {
        return [
          {
            '@context': 'http://schema.org',
            '@type': 'MusicRecording',
            '@id': this.canonicalURL,
            url: this.canonicalURL,
            duration: this.trackData.duration,
            name: this.trackName,
            inAlbum: {
              '@type': 'MusicAlbum',
              '@id': `https://${process.env.VUE_APP_MUZIK_LISTEN}.${
                process.env.VUE_APP_MUZIK_DOMAIN
              }/${this.$i18n.localePath()}/composers/works/${this.trackData.movement.work.id}`,
              name: this.workName
            },
            byArtist: {
              '@type': 'MusicGroup',
              '@id': `https://${process.env.VUE_APP_MUZIK_LISTEN}.${
                process.env.VUE_APP_MUZIK_DOMAIN
              }/${this.$i18n.localePath()}/composers/${this.trackData.movement.work.people.id}`,
              name: this.composerName
            },
            recordingOf: {
              '@type': 'MusicComposition',
              name: this.trackName
            }
          },
          {
            '@context': 'http://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                item: {
                  '@id': `https://${process.env.VUE_APP_MUZIK_LISTEN}.${
                    process.env.VUE_APP_MUZIK_DOMAIN
                  }/${this.$i18n.localePath()}/`,
                  name: this.$t('LISTEN.TITLE')
                }
              },
              {
                '@type': 'ListItem',
                position: 2,
                item: {
                  '@id': `https://${process.env.VUE_APP_MUZIK_LISTEN}.${
                    process.env.VUE_APP_MUZIK_DOMAIN
                  }/${this.$i18n.localePath()}/composers/${this.trackData.movement.work.people.id}`,
                  name: this.composerName
                }
              },
              {
                '@type': 'ListItem',
                position: 3,
                item: {
                  '@id': `${process.env.VUE_APP_MUZIK_LISTEN}.${
                    process.env.VUE_APP_MUZIK_DOMAIN
                  }/${this.$i18n.localePath()}/composers/works/${this.trackData.movement.work.id}`,
                  name: this.workName
                }
              },
              {
                '@type': 'ListItem',
                position: 4,
                item: {
                  '@id': `${process.env.VUE_APP_MUZIK_LISTEN}.${
                    process.env.VUE_APP_MUZIK_DOMAIN
                  }/${this.$i18n.localePath()}/composers/works/tracks`,
                  name: this.trackName
                }
              }
            ]
          }
        ]
      } else {
        return []
      }
    }
  },
  watch: {
    '$route.params.id'(val) {
      this.getTrack()
    }
  },
  mounted() {
    this.getTrack()
  },
  methods: {
    displayTrackName,
    displayComposerName,
    displayComposerDescription,
    displayWorkName,
    displayWorkAliases,
    displayWorkDescription,
    displayMovementName,
    displayPerformerName,
    displayPerformerPosition,
    parseRewriteURL(unparsedIdStr) {
      const MuzikListenV4Reg = /^[A-F\d]{8}-[A-F\d]{4}-4[A-F\d]{3}-[89AB][A-F\d]{3}-[A-F\d]{12}/gi
      const MuzikListenV3Reg = /^[A-Z\d]{6}/gi
      let parsedIdStr = ''
      if (MuzikListenV4Reg.test(unparsedIdStr)) {
        parsedIdStr = unparsedIdStr.match(MuzikListenV4Reg)[0] // MUZIK LISTEN v4 (UUID.v4) id format
      } else if (MuzikListenV3Reg.test(unparsedIdStr)) {
        parsedIdStr = unparsedIdStr.match(MuzikListenV3Reg)[0] // MUZIK LISTEN v3 id format
      } else {
        parsedIdStr = unparsedIdStr
      }
      return parsedIdStr
    },
    async getTrack() {
      this.loaded = false
      const unparsedIdStr = this.$route.params.id.replace('.html', '') // external share link
      const trackId = this.parseRewriteURL(unparsedIdStr)
      const trackRewrite = unparsedIdStr.replace(trackId, '')
      // const trackId = this.$route.params.id
      let res = await TrackService.getTrackById(trackId)
      if (res !== null && res.movement && res.movement.work) {
        let trackPerformersId = []
        res.performer = {}
        res.composer_id = ''
        res.movement.work.people.langs.forEach(lang => {
          if (res.composer_id === '') {
            res.composer_id = lang.people_id
          }
        })
        res.performers.forEach((performer, index) => {
          res.performer[performer.people_id] = {}
          res.performer[performer.people_id].position = {}
          res.performer[performer.people_id].langs = performer.people && performer.people.langs
          res.performer[performer.people_id].position = performer.position
          trackPerformersId.push(performer.people_id)
          // performer.position.forEach((position, index) => {
          //   res.performer[performer.id].position[index] = position
          // })
        })
        trackPerformersId.sort()

        // get other relative tracks
        let genreId = res.movement && res.movement.work && res.movement.work.genre_id
        let isNonOpera = this.genreIdOfNonOpera.indexOf(genreId) > -1
        this.otherTrack = {}
        if (isNonOpera) {
          this.otherTrack[res.id] = res.album ? res.album.filter(album => {
            if (res.performers.length === album.performers.length) {
              let albumPerformersId = []
              album.performers.forEach(performer => {
                albumPerformersId.push(performer.people_id)
              })
              albumPerformersId.sort()
              return JSON.stringify(trackPerformersId) === JSON.stringify(albumPerformersId)
            }
          }) : []
          this.otherTrack[res.id] = this.otherTrack[res.id].filter(track => {
            return track.id !== res.id
          })
        } else {
          let performerArray = []
          if (res.album) {
            res.album.forEach(track => {
              performerArray = performerArray.concat(track.performers)
            })
          }
          // filter duplicate performer and sort by position
          if (performerArray.length > 0) {
            const sortedPerformerList = performerArray
              .filter((item, index) => {
                return (
                  index ===
                  performerArray.findIndex(obj => {
                    return obj.people_id === item.people_id
                  })
                )
              })
              .sort((a, b) => {
                return a.position.sort - b.position.sort
              })
            res.album[0].performers = sortedPerformerList
          }
          this.otherTrack[res.id] = res.album ? res.album : []
        }
        this.trackData = res
        if (this.trackData.id !== unparsedIdStr) {
          // rewrite old version id
          this.$router.replace({ params: { id: this.trackData.id } })
        }
        this.loaded = true
      } else {
        // check crawler
        if (/bot|google|baidu|bing|msn|duckduckbot|teoma|slurp|yandex/i.test(window.navigator.userAgent)) {
          window.location.href = `${process.env.VUE_APP_API_HOST}/404` // intended to return 404 status!
          return false
        }

        if (trackRewrite) {
          this.loaded = true
          const queryKeyword = trackRewrite.split('-').join(' ')
          this.$router.push({
            name: 'search',
            query: {
              type: 'all',
              q: queryKeyword
            }
          })
        } else {
          this.loaded = true
        }
      }
      if (!this.initialClick) {
        // still not click once, auto set queue and player to current playlist
        this.$store.commit('TOGGLE_PLAYER_RANDOM', false)
        this.$store.commit('RESET_QUEUE')
        this.$store.commit('SET_TRACK_TO_QUEUE', res)
        this.$store.commit('SET_PLAYER_INDEX', 0)
      }
    },
    setTrackToQueue(track) {
      if (!this.initialClick) {
        // Trigger click-to-play policy
        document.querySelector('#audioPlayer').play()
        document.querySelector('#audioPlayer').pause()
      }
      if (this.random) {
        this.$store.commit('TOGGLE_PLAYER_RANDOM', false)
      }
      this.$store.commit('RESET_QUEUE')
      this.$store.commit('SET_TRACK_TO_QUEUE', track)
      this.$store.commit('SET_PLAYER_INDEX', 0)
      this.$nextTick(() => {
        this.$store.commit('TOGGLE_PLAYER_PAUSED', false)
      })
    },
    addToPlaylist() {
      if (this.isAuthenticated) {
        this.openAddingModal = true
      } else {
        this.openGoToLoginModal = true
      }
    },
    async playTrackList(val) {
      if (!this.initialClick) {
        // Trigger click-to-play policy
        document.querySelector('#audioPlayer').play()
        document.querySelector('#audioPlayer').pause()
      }
      let trackIdArray = []
      val.forEach(track => {
        trackIdArray.push(track.id)
      })
      let res = await TrackService.getTracks({ id: trackIdArray })
      let playlist = []
      playlist = trackIdArray
        .map(trackId => {
          return res.data.find(item => item.id === trackId)
        })
        .filter(track => track) // filter undefinded obj
      this.$store.commit('TOGGLE_PLAYER_RANDOM', false)
      this.$store.commit('RESET_QUEUE')
      this.$store.commit('SET_PLAYLIST_TO_QUEUE', playlist)
      this.$store.commit('SET_PLAYER_INDEX', 0)
      this.$nextTick(() => {
        this.$store.commit('TOGGLE_PLAYER_PAUSED', false)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.muzik-composer {
  // padding: 0 $padding-lg-grid-x1 66px;
  padding-bottom: 66px;
  .breadcrumbs {
    padding: 24px 0;
  }
  .dummy {
    text-align: left;
    margin-bottom: 60px;
  }
  .loader-container {
    text-align: center;
    .loader {
      margin-bottom: 40px;
    }
  }
  .unite {
    /deep/ .people-track {
      position: relative;
      padding-left: 100px;
      /deep/ .name {
        padding-left: 0;
      }
      /deep/ .btn-player {
        position: absolute;
        top: 0;
        left: 0;
      }
      /deep/ .btn-group .mk-btn {
        width: 182px;
      }
    }
  }
}

@media only screen and (min-width: 1440px) {
  // default
}

@media only screen and (max-width: 1439.98px) {
  .muzik-composer {
    // padding: 0 $padding-md-grid-x1;
    padding-bottom: 66px;
  }
}

@media only screen and (max-width: 1023.98px) {
  .muzik-composer {
    // padding: 0 $padding-sm-grid-x1;
    padding-bottom: 66px;
    .dummy {
      display: none;
    }
  }
}

@media only screen and (max-width: 767.98px) {
  .muzik-composer {
    // padding: 0 $padding-md-grid-x1;
    padding-bottom: 66px;
    .unite {
      /deep/ .people-track {
        position: relative;
        padding-left: 0;
        /deep/ .name {
          padding-left: 8px;
        }
        /deep/ .btn-player {
          position: relative;
        }
        /deep/ .btn-group .mk-btn {
          width: calc(50% - 7.5px);
        }
      }
    }
  }
}
</style>
